import { Stack } from '@mui/material';
import { Heading } from '@sparemin/blockhead';

import TableCells from 'components/TableCells';
import { Column, CellProps } from 'react-table';
import { displayDate } from 'utils/date';
import { sorters } from 'utils/table';
import { SocialShareVideos } from '../types';
import { socialPlatformInfoLookup } from './socialPlatformLogoLookup';
import * as S from './styles';

export const defaultSort = [{ id: 'posted', desc: false }];

const columns: ReadonlyArray<Column<SocialShareVideos>> = [
  {
    Header: 'Date Posted',
    id: 'posted',
    accessor: 'createdAtMillis',
    sortType: sorters.sortByDate('createdAtMillis'),

    Cell: ({ row }: CellProps<SocialShareVideos>) => (
      <Stack height="100%" justifyContent="center">
        {displayDate(row.original.createdAtMillis, 'MM.DD.YYYY')}
      </Stack>
    ),
    disableSortBy: false,
  },
  {
    Header: () => <S.PlatformIcon />,
    id: 'app',
    Cell: ({ row }: CellProps<SocialShareVideos>) => (
      <Stack height="100%" justifyContent="center">
        {socialPlatformInfoLookup[row.original.platform].icon}
      </Stack>
    ),
    width: 50,
  },
  {
    Header: 'Video Name',
    id: 'video',
    Cell: ({ row }: CellProps<SocialShareVideos>) => (
      <TableCells.SocialVideoCell
        videoName={row.original.sharePostTitle}
        projectName={row.original.projectName ?? 'Untitled'}
        imgUrl={row.original.previewThumbnailImageUrl}
        videoUrl={row.original.sharePostUrl}
        socialPlatform={
          socialPlatformInfoLookup[row.original.platform].brandName
        }
      />
    ),
    disableSortBy: true,
    width: 800,
  },
  {
    Header: () => (
      <TableCells.HeaderCell text={<Heading level={2}>Views</Heading>} />
    ),
    id: 'views',
    Cell: ({ row }: CellProps<SocialShareVideos>) => (
      <TableCells.NumericCell
        value={row.original.statistics.viewCount}
        isValueStale={row.original.statistics.isViewCountStale}
      />
    ),
    disableSortBy: true,
    width: 100,
  },
  {
    Header: () => (
      <TableCells.HeaderCell text={<Heading level={2}>Likes</Heading>} />
    ),

    id: 'likes',
    Cell: ({ row }: CellProps<SocialShareVideos>) => (
      <TableCells.NumericCell value={row.original.statistics.likeCount} />
    ),
    disableSortBy: true,
    width: 100,
  },
  {
    Header: () => (
      <TableCells.HeaderCell text={<Heading level={2}>Comments</Heading>} />
    ),
    id: 'comments',
    Cell: ({ row }: CellProps<SocialShareVideos>) => (
      <TableCells.NumericCell value={row.original.statistics.commentCount} />
    ),
    disableSortBy: true,
    width: 100,
  },
];

export default columns;
